var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.authority === _setup.Authority.Owner)?_c(_setup.CheckHome):(_setup.authority === _setup.Authority.Leader)?_c(_setup.LeaderHome):(_setup.authority === _setup.Authority.Accountant)?_c(_setup.AccountantHome):_c(_setup.ApprovalHome)
}
var staticRenderFns = []

export { render, staticRenderFns }